import React from "react";
import {useCreateTeacherForm} from "../../hook/useCreateTeacherForm";
import { AutoCompleteSingleOption } from "common/form/autocompleteSingleOption";
import { AlternativeAutoComplete } from "common/form/autoComplete/_alternativeAutoComplete";

export const BankName = ()=>{
    const {bankName} = useCreateTeacherForm()
    const {methods} = bankName
    return (
        <AlternativeAutoComplete
            inputProps={{
                categoryList: [],
                categoryHidden: true,
                readOnly: true,
                categoryValue: {name: 'Vui lòng chọn ngân hàng', value: ''},
                label: <>Ngân hàng</>,
                placeholder: 'Vui lòng chọn ngân hàng',
                value: bankName?.value?.name,
            }}
            menuProps={{
                empty:
                    bankName?.list?.length <= 0
                    ? 'Không tìm thấy ngân hàng'
                    : '',
            }}
            searchInputProps={{
                placeholder: 'Tìm kiếm ngân hàng',
                onChange: methods.onKeywordChange,
            }}
        >
            {bankName?.list?.length > 0 &&
                bankName.list.map((item, i) => (
                <AutoCompleteSingleOption
                    key={item.id}
                    data-active={item.id === bankName?.value?.id}
                    onClick={() => methods?.onChange(item)}
                >
                    {item?.name}
                </AutoCompleteSingleOption>
            ))}
        </AlternativeAutoComplete>
    )
}